export interface NavEntry {
  readonly to: string;
  readonly label: string;
  readonly icon: string;
}

export const NAV_ITEMS: ReadonlyArray<NavEntry> = [
  { to: '/', label: 'Accueil', icon: '🏠' },
  { to: '/discover', label: 'Découvrir', icon: '🔍' },
  { to: '/library', label: 'Étagères', icon: '📚' },
  { to: '/upcoming', label: 'Sorties', icon: '📅' },
  { to: '/profile', label: 'Profil', icon: '👤' },
];
